export default __webpack_public_path__ + "9fb961f7a1a1028e3684dda5c331d66c.png";